// extracted by mini-css-extract-plugin
export default {"cardThanksContent":"styles_cardThanksContent__ZB4G8","selectedRating":"styles_selectedRating__xQO0H","thanksText":"styles_thanksText__6RBpz"};